import React, { FC, useState, useEffect, useCallback } from 'react';
import { isEmpty } from 'lodash';

import { setEmail, skipEmail } from './signupStore';
import { Layout } from '../../components/Layout';
import { ButtonWithLoading } from '../global/ButtonWithLoading';
import { isEmailValid } from '../user/utils';
import { useDispatchWithHistory } from '../actionWithHistory';
import { useRedirectOnAuthStepChangeEffct } from '../sharedHooks';
import { useSelector } from 'react-redux';
import { getActivation } from '../dbStore/dbStore';

export const EmailVerificationPage: FC = () => {
  const activation = useSelector(getActivation);
  const dispatchWithHistory = useDispatchWithHistory();
  const [mail, setMail] = useState('');
  const [mailError, setMailError] = useState('');

  useRedirectOnAuthStepChangeEffct();

  useEffect(() => {
    if (!isEmpty(mail) && !isEmailValid(mail)) {
      setMailError('Email is not valid');
    } else {
      setMailError('');
    }
  }, [mail]);

  const canVerifyEmail = !isEmpty(mail);
  const sendConfirmation = () => {
    dispatchWithHistory(setEmail, {
      email: mail,
    });
  };


  const handleOnSkipEmailCLick = useCallback(() => {
    dispatchWithHistory(skipEmail, {});
  }, [dispatchWithHistory]);

  const mailValidationClass = !isEmpty(mailError) ? 'c-input--validation' : '';

  return (
    <Layout
      footer={
        <footer className="l-footer">
          <ButtonWithLoading onClick={sendConfirmation} isDisabled={!canVerifyEmail}>
            Send Confirmation
          </ButtonWithLoading>
          {activation && activation.nextStepSkippable &&
          <div className="l-row l-row--mt-16">
            <button className="c-link" onClick={handleOnSkipEmailCLick}>
              Skip
            </button>
          </div>
          }
        </footer>
      }
    >
      <button className="c-close" type="button">
        <span className="c-close__inner">
          <svg className="icon icon--cross">
            <use xlinkHref="img/_icons.svg#icon--cross" />
          </svg>
        </span>
      </button>
      <div className="l-row">
        <div className="c-title">Verify Email Address!</div>
      </div>
      <div className="l-row l-row--mt-16">
        <div className="c-text">
          Please enter your valid email address. 
        </div>
      </div>
      <div className="l-row">
        <div className={`c-input ${mailValidationClass}`}>
          <div className="c-input__message c-input__message--error">{mailError}</div>
          <label className="c-input__label">
            <input
              className="c-input__type"
              type="text"
              placeholder=" "
              value={mail}
              onChange={(event) => setMail(event.target.value)}
            />
            <span className="c-input__title">Email</span>
          </label>
        </div>
      </div>
    </Layout>
  );
};
